export type SinglePromise = <T>(
  key: string,
  executor?: () => Promise<T>,
) => Promise<T>;

export const single = (): SinglePromise => {
  const cache = new Map<string, Promise<unknown>>();

  return <T>(key: string, executor?: () => Promise<T>): Promise<T> => {
    const cached = cache.get(key);
    if (cached) return cached as Promise<T>;

    if (!executor) {
      throw new Error('Promise cache miss without executor.');
    }

    const promise = executor();
    cache.set(key, promise);
    const clear = (): void => {
      cache.delete(key);
    };
    promise.then(clear).catch(clear);
    return promise;
  };
};

export const chunked = async <I, T>(
  input: I[],
  mapper: (input: I) => Promise<T>,
  n = 10,
): Promise<PromiseSettledResult<T>[]> => {
  const result = [];

  for (let i = 0; i < input.length; i += n) {
    const inputChunk = input.slice(i, i + n);
    // TODO: will be dealt with in TP-3269
    result.push(await Promise.allSettled(inputChunk.map(mapper)));
  }

  return result.flat();
};
